import { useMutation, useQueryClient } from '@tanstack/react-query';
import { shopsService } from '../services/shops.service';
import type { UpdateShopData } from '../types/shops.types';

export function useUpdateShop() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateShopData }) =>
      shopsService.updateShop(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['shops'] });
      queryClient.invalidateQueries({ queryKey: ['shops', id] });
    },
  });
}

export function useUpdateShopStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: 'online' | 'offline' }) =>
      shopsService.updateShopStatus(id, status),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['shops'] });
      queryClient.invalidateQueries({ queryKey: ['shops', id] });
    },
  });
}

export function useUpdateShopDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, delivery }: { id: string; delivery: 'store' | 'home' | 'both' }) =>
      shopsService.updateShopDelivery(id, delivery),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['shops'] });
      queryClient.invalidateQueries({ queryKey: ['shops', id] });
    },
  });
}
